import React, { FC, useCallback, useRef, useState } from 'react';

import { Column, DataGrid, MasterDetail } from 'devextreme-react/data-grid';

import { AppLayoutTop } from 'components/appComponents';
import { useAuth } from 'context/auth';
import { useModal } from 'context/ModalProvider/useModal';
import { Button } from 'devextreme-react';

import { useGetMethodOfReceptionListQuery } from 'bus/methodOfReception/services';

import { DeleteModal, MasterDetailView } from './components';
import { MethodOfReceptionCreateModal, MethodOfReceptionEditModal } from './components/MethodOfReceptionModal';

type Props = {
  requestId: number | string;
};

const MethodOfReception: FC<Props> = ({ requestId }) => {
  const refGrid = useRef<DataGrid | null>(null);
  const { getClaims }: any = useAuth();
  const { showModal, hideModal } = useModal();

  const [modalIsVisibleDelete, setModalIsVisibleDelete] = useState(false);
  const [methodReceptionId, setMethodReceptionId] = useState<number>();
  const [taskIsArch] = useState<boolean>(window.location.pathname.indexOf('arch') >= 0);

  const {
    isLoading: isLoadingList,
    data: methodOfReceptionList,
    refetch,
  } = useGetMethodOfReceptionListQuery({ requestId });

  const isCanEditRequest = getClaims(['CanEditRequest']);
  const isCanEditArchiveTask = getClaims(['CanEditArchiveTask']);
  const isCanEditMethodOfReception = getClaims(['CanChangeMethodOfReception']);

  const isCanEdit = taskIsArch ? isCanEditArchiveTask : isCanEditRequest;

  const handleCloseDeleteModal = () => {
    setModalIsVisibleDelete(false);
  };

  const refresh = () => refGrid.current?.instance.refresh();

  const handleShowCreateModal = useCallback(() => {
    showModal(<MethodOfReceptionCreateModal onClose={hideModal} requestId={requestId} refresh={refresh} />);
  }, [hideModal, requestId, showModal]);

  const handleShowEditModal = useCallback(
    (methodReceptionId: number) => {
      showModal(
        <MethodOfReceptionEditModal
          onClose={hideModal}
          requestId={requestId}
          refresh={refresh}
          methodReceptionId={methodReceptionId}
        />,
      );
    },
    [hideModal, requestId, showModal],
  );

  if (isLoadingList || !methodOfReceptionList) {
    <div>Загрузка...</div>;
  }

  return (
    <div>
      {modalIsVisibleDelete && methodReceptionId && (
        <DeleteModal
          changeVisible={handleCloseDeleteModal}
          detailId={methodReceptionId}
          refresh={refresh}
          visible={modalIsVisibleDelete}
        />
      )}

      <AppLayoutTop title="">
        <Button className="send mr-2" icon="refresh" onClick={refetch} />
        <Button width={120} text="Добавить" type="default" onClick={handleShowCreateModal} visible={isCanEdit} />
      </AppLayoutTop>

      <DataGrid
        dataSource={methodOfReceptionList}
        remoteOperations={false}
        showBorders={true}
        id="methodOfReception"
        showColumnHeaders={false}
        ref={refGrid}
      >
        <MasterDetail enabled={true} component={(props) => <MasterDetailView methodOfReception={props.data.data} />} />
        <Column dataField="displayName" caption="displayName" />
        <Column dataField="pumpQuantity" caption="pumpQuantity" />

        <Column
          dataField="actions"
          caption=""
          width={120}
          visible={isCanEditMethodOfReception}
          allowFiltering={false}
          allowSorting={false}
          cellRender={(data) => (
            <>
              <Button
                icon="edit"
                type="default"
                stylingMode="text"
                onClick={() => {
                  handleShowEditModal(data.data.id);
                }}
              />

              <Button
                icon="trash"
                type="default"
                stylingMode="text"
                onClick={() => {
                  setMethodReceptionId(data.data.id);
                  setModalIsVisibleDelete(true);
                }}
              />
            </>
          )}
        />
      </DataGrid>
    </div>
  );
};

export default MethodOfReception;
